"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.email.contacts': '联系人',
    'whatsapp.email.noContacts': '未找到电子邮件联系人。',
    'whatsapp.email.loadFailed': '无法加载电子邮件联系人。',
    'whatsapp.email.stats.contacts': '联系人',
    'whatsapp.email.stats.total': '总计',
    'whatsapp.email.trackLogs': '跟踪日志',
    'whatsapp.email.noLogs': '暂无跟踪日志。',
};
